import React from 'react';
import _axios from 'axios';
import moment from 'moment-timezone';
import { msalAuthService } from './msalAuthService';
import secureStorage from './secureStorage';

class HttpHandler {
  constructor(
    checkToken = true,
    baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000' || process.env.Charge_API_QUERY_URL
  ) {
    this.checkToken = checkToken;
    this.baseURL = baseURL;
  }
  axios = (baseURL) => {
    const instance = _axios.create({
      baseURL: this.baseURL,
      timeout: 5000000,
    });
    return instance;
  };

  navigateTo(url) {
    window.navigate(url);
  }

  logout() {
    msalAuthService.logout();
  }

  login() {
    msalAuthService.login();
  }

  // post method
  async post(url, data, contentType = 'application/json') {
    let headers = await this.getHeader(contentType);
    // token 過期
    if (headers === null) {
      this.navigateTo('error401');
    }

    return this.axios()
      .post(url, data, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          return { success: false, message: '連線錯誤.' };
        }
        if (error.response.status === 401) {
          this.navigateTo('error401');
        } else if (error.response.status === 422) {
          return { success: false, message: '後端API資料驗證失敗, 請確認.' };
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .finally(() => {});
  }

  // put method
  async put(url, data, contentType = 'application/json') {
    let headers = await this.getHeader(contentType);
    // token 過期
    if (headers === null) {
      this.navigateTo('error401');
    }

    return this.axios()
      .put(url, data, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          return { success: false, message: '連線錯誤.' };
        }
        if (error.response.status === 401) {
          this.navigateTo('error401');
        } else if (error.response.status === 422) {
          return { success: false, message: '後端API資料驗證失敗, 請確認.' };
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .finally(() => {});
  }

  // get method
  async get(url) {
    let headers = await this.getHeader('application/json');
    // token 過期
    if (headers === null) {
      this.navigateTo('error401');
    }

    return this.axios()
      .get(url, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          return { success: false, message: '連線錯誤.' };
        }
        if (error.response.status === 401) {
          this.navigateTo('error401');
        } else if (error.response.status === 422) {
          return { success: false, message: '後端API資料驗證失敗, 請確認.' };
        } else {
          return { success: false, message: 'http handler error' };
        }
      });
  }

  // delete method
  async delete(url) {
    let headers = await this.getHeader('application/json');
    // token 過期
    if (headers === null) {
      this.navigateTo('error401');
    }

    return this.axios()
      .delete(url, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
          return { success: false, message: '連線錯誤.' };
        }
        if (error.response.status === 401) {
          this.navigateTo('error401');
        } else if (error.response.status === 422) {
          return { success: false, message: '後端API資料驗證失敗, 請確認.' };
        } else {
          return { success: false, message: 'http handler error' };
        }
      });
  }

  // // download method (未來若要使用，response.data需實作檢查檔案內容，不然會被源掃掃到)
  // async fileDownload(url, fileExtension, fileName = 'output') {
  //   let headers = await this.getHeader('');
  //   // token 過期
  //   if (headers === null) {
  //     window.logout('登入逾時', '請重新登入', 'fail');
  //   }

  //   headers.responseType = 'blob';

  //   this.axios()
  //     .get(url, { headers: headers })
  //     .then((response) => {
  //       if (!response.data.success) {
  //         alert(response.data.message);
  //       } else {
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         fileName = fileName + '.' + fileExtension;
  //         link.setAttribute('download', fileName);
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.message === 'Network Error') {
  //         return { success: false, message: '連線錯誤.' };
  //       }
  //       if (error.response.status === 401) {
  //         window.logout('登入逾時', '請重新登入', 'fail');
  //       } else if (error.response.status === 422) {
  //         return { success: false, message: '後端API資料驗證失敗, 請確認.' };
  //       } else {
  //         return { success: false, message: 'http handler error' };
  //       }
  //     });
  // }

  async getHeader(content_type = 'application/json') {
    let headers;

    if (content_type !== '') {
      headers = { 'Content-Type': content_type };
    } else {
      headers = {};
    }

    if (!this.checkToken) {
      return headers;
    }

    /*
    2025.03 起改為使用 AD 登入
    因此統一改為使用 MSAL 的 access token 挾帶於 header 中
    */

    // 取得 account
    const account = msalAuthService.getAccount();
    if (!account) {
      // 如果沒有 account，表示尚未登入，所以直接進行登入
      msalAuthService.login();
    }

    let accessToken = null;

    try {
      // 取得 token
      accessToken = await msalAuthService.getAccessToken();
    } catch (error) {
      console.error('取得 token 失敗', error);
      msalAuthService.login(); // 嘗試重新登入
    }

    if (!accessToken) {
      return null;
    }

    headers.authorization = 'Bearer ' + accessToken;
    return headers;
  }

  async getHeaderDeprecated(content_type = 'application/json') {
    let headers;

    if (content_type !== '') {
      headers = { 'Content-Type': content_type };
    } else {
      headers = {};
    }

    const accessToken = secureStorage.getItem('irentAccessToken');
    const refreshToken = secureStorage.getItem('irentRefreshToken');
    const accessExpTime = secureStorage.getItem('irentAccessTokenExpireTime');
    const refreshExpTime = secureStorage.getItem('irentRefreshTokenExpireTime');

    const now = moment();
    const accessExpMoment = moment(accessExpTime, 'YYYY/MM/DD HH:mm:ss');
    const refreshExpMoment = moment(refreshExpTime, 'YYYY/MM/DD HH:mm:ss');

    if (this.checkToken) {
      if (now.isAfter(accessExpMoment) && now.isAfter(refreshExpMoment)) {
        // 全部逾時
        return null;
      } else if (now.isAfter(accessExpMoment)) {
        // refresh token
        headers.authorization = 'Bearer ' + refreshToken;
        return this.axios()
          .post('/auth/refresh_token', {}, { headers: headers })
          .then((response) => {
            if (response.status === 200) {
              return response.data;
            } else {
              return null;
            }
          })
          .then((result) => {
            // 更新 AccessToken
            secureStorage.setItem('irentAccessToken', result.data.token);
            // 延長token duration
            const tokenDuration = parseInt(
              secureStorage.getItem('irentAccessTokenExpireMinutes')
            );
            secureStorage.setItem(
              'irentAccessTokenExpireTime',
              moment(new Date())
                .add(tokenDuration, 'minutes')
                .format('YYYY/MM/DD hh:mm:ss')
            );
            headers.authorization = 'Bearer ' + result.data.token;
            return headers;
          })
          .catch((error) => {
            if (error.message === 'Network Error') {
              return { success: false, message: '連線錯誤.' };
            }
            if (error.response.status === 401) {
              return null;
            } else if (error.response.status === 422) {
              return {
                success: false,
                message: '後端API資料驗證失敗, 請確認.',
              };
            } else {
              return null;
            }
          });
      } else {
        // token沒過期
        headers.authorization = 'Bearer ' + accessToken;
        return headers;
      }
    } else {
      return headers;
    }
  }
}

// auth helper
class AuthValid {
  // save login info
  static storeAuth(access, refresh) {
    secureStorage.setItem('irentAccessToken', access);
    secureStorage.setItem('irentRefreshToken', refresh);

    const payLoad = AuthValid.parseJwt(access);

    // 使用者資訊
    const userInfo = payLoad.user_info;
    secureStorage.setItem('userId', userInfo.id);
    secureStorage.setItem('userAccount', userInfo.account);
    // SecureStorage.setItem('userName', userInfo.name);
    secureStorage.setItem('userDepartment', userInfo.department);
    // SecureStorage.setItem('userReason', userInfo.reason);
    secureStorage.setItem(
      'userFunctionTree',
      JSON.stringify(userInfo.function_tree)
    );

    // 登入時間
    // SecureStorage.setItem(
    //   'loginTime',
    //   moment
    //     .utc(payLoad.token_time)
    //     .tz(moment.tz.guess())
    //     .format('YYYY/MM/DD HH:mm:ss')
    // );

    // AccessToken 過期分鐘數
    secureStorage.setItem(
      'irentAccessTokenExpireMinutes',
      payLoad.token_expire_minutes
    );

    // RefreshToken 過期分鐘數
    secureStorage.setItem(
      'irentRefreshTokenExpireMinutes',
      payLoad.re_token_expire_minutes
    );

    // AccessToken 過期時間
    secureStorage.setItem(
      'irentAccessTokenExpireTime',
      moment(new Date())
        .add(parseInt(payLoad.token_expire_minutes), 'minutes')
        .format('YYYY/MM/DD HH:mm:ss')
    );

    // RefreshToken 過期時間
    secureStorage.setItem(
      'irentRefreshTokenExpireTime',
      moment(new Date())
        .add(parseInt(payLoad.re_token_expire_minutes), 'minutes')
        .format('YYYY/MM/DD HH:mm:ss')
    );
  }

  static parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }
}

function storeUserInfo(userInfo) {
  secureStorage.setItem('userId', userInfo.id);
  secureStorage.setItem('userAccount', userInfo.account);
  secureStorage.setItem('userName', userInfo.name);
  secureStorage.setItem('userDepartment', userInfo.department);
  secureStorage.setItem('userReason', userInfo.reason);
  secureStorage.setItem(
    'userFunctionTree',
    JSON.stringify(userInfo.function_tree)
  );
}

export { HttpHandler, AuthValid, storeUserInfo };
